import { endpoints } from "@/services";
import { useApiStore, useComponentStore } from "@/store";
import { usePin, useAPI } from "@/hooks";
import { useCallback } from "react";
import { Button } from "antd";

export const TransactionPin = () => {
  const { payload } = useApiStore((state) => state);
  const { setState, modal } = useComponentStore((state) => state);
  const { inputComponents, isPinInputedCompletely } = usePin({
    length: 4,
    inputClassName:
      "h-[100px] w-[80px] text-center border-[1px] border-[#CCCCCC] rounded-lg font-bold max-md:!min-w-[40px] text-[60px]",
    inputGap: "gap-3",
    apiKey: "transactionPin",
    isConceal: true,
  });
  const { callPostData, posting } = useAPI();

  const closeModal = useCallback(() => {
    setState("modal", { ...modal, open: false });
  }, []);

  const createPin = useCallback(() => {
    callPostData({
      url: endpoints.Wallet.CreatePin,
      showToastAfterApiResponse: true,
      callBackApiResponse: closeModal,
      request: {
        transactionPin: payload?.transactionPin?.join(""),
        transactionPinAgain: payload?.transactionPin?.join(""),
      },
    });
  }, [payload]);

  return (
    <div className="flex flex-col gap-4 mt-4 px-4">
      {inputComponents}
      <Button
        onClick={createPin}
        loading={posting}
        className="w-full h-10 font-bold border-none text-white bg-green-600 hover:!text-white mt-3"
        disabled={!isPinInputedCompletely}
      >
        Proceed
      </Button>
    </div>
  );
};
